import * as React from 'react';
import { gql } from '@apollo/client';
import {
  useCreateTimeslotMutation,
  useGetCategoriesLazyQuery,
  useGetSocialProfilesLazyQuery,
  useGetTimeslotsLazyQuery,
  useUpdateTimeslotMutation
} from '../../../../models/graphql';
import { AddEditTimeslotModalController, AddEditTimeslotModalControllerProps } from './AddEditTimeslotModal.controller';

export type AddEditTimeslotModalApolloProps = Omit<
  AddEditTimeslotModalControllerProps,
  | 'getProfiles'
  | 'profilesResults'
  | 'getCategories'
  | 'categoriesResults'
  | 'createTimeslot'
  | 'updateTimeslot'
  | 'getTimeslots'
  | 'timeslotsResults'
> & {
  // ...
};

gql`
  mutation CreateTimeslot($workspaceId: ID!, $input: TimeslotInput!) {
    createTimeslot(workspaceId: $workspaceId, input: $input) {
      ...CoreTimeslotFields
      category {
        id
        name
        color
      }
      socialProfiles {
        id
      }
    }
  }

  mutation UpdateTimeslot($timeslotId: ID!, $input: TimeslotInput!) {
    updateTimeslot(timeslotId: $timeslotId, input: $input) {
      ...CoreTimeslotFields
      category {
        id
      }
      socialProfiles {
        id
      }
    }
  }
`;

export const AddEditTimeslotModalApollo = (props: AddEditTimeslotModalApolloProps): JSX.Element => {
  const [getProfiles, profilesResults] = useGetSocialProfilesLazyQuery();
  const [getCategories, categoriesResults] = useGetCategoriesLazyQuery();
  const [getTimeslots, timeslotsResults] = useGetTimeslotsLazyQuery();
  const [createTimeslot] = useCreateTimeslotMutation();
  const [updateTimeslot] = useUpdateTimeslotMutation();

  const controllerProps: AddEditTimeslotModalControllerProps = {
    ...props,
    getProfiles,
    profilesResults,
    getCategories,
    categoriesResults,
    getTimeslots,
    timeslotsResults,
    createTimeslot,
    updateTimeslot
  };

  return <AddEditTimeslotModalController {...controllerProps} />;
};
